import React, { useContext, useEffect, useMemo, useState } from 'react';
import { App03WorkItemType, EntityValidations, IApp03WorkItemType, ISpecificEntityFormProps } from '../../types';
import styles from '../../styles/cr.module.scss';
import { CrTextField } from '../cr/CrTextField';
import { CrDropdown } from '../cr/CrDropdown';
import { EntityForm } from '../EntityForm';
import { DataContext } from '../DataContext';
import { IntegrationContext } from '../IntegrationContext';
import { App03Frameworks } from '../../types/App03Workflow';
import { App03WorkItemSystemTypes } from '../../types/App03WorkItemType';
import { CrCheckbox } from '../cr/CrCheckbox';



class App03WorkItemTypeValidations extends EntityValidations {
    public SystemType: string = null;
    public Owners: string = null;
}

interface App03WorkItemTypeFormProps extends ISpecificEntityFormProps {
    frameworkID: App03Frameworks;
}

export const App03WorkItemTypeForm = (props: App03WorkItemTypeFormProps): React.ReactElement => {
    const { disableGroupManagement } = useContext(IntegrationContext);
    const { dataServices, lookupData, } = useContext(DataContext);


    const validateEntity = (workItemType: IApp03WorkItemType): Promise<App03WorkItemTypeValidations> => {
        const errors = new App03WorkItemTypeValidations();

        if (workItemType.Title === null || workItemType.Title === '') {
            errors.Title = `Work Item Type is required`;
            errors.Valid = false;
        }
        else {
            errors.Title = null;
        }

        if (workItemType.SystemType === null || workItemType.SystemType === '') {
            errors.SystemType = `System Type is required`;
            errors.Valid = false;
        } else {
            errors.SystemType = null;
        }

        return Promise.resolve(errors);
    };


    return (
        <EntityForm<IApp03WorkItemType, App03WorkItemTypeValidations>
            {...props}
            entityName='Work Item Type'
            renderFormFields={(changeHandlers, formState) => {
                const { FormData: workItemType, ValidationErrors: errors } = formState;
                return (
                    <div>
                        <CrTextField
                            label="Work Item Type"
                            maxLength={100}
                            className={styles.formField}
                            required={true}
                            value={workItemType.Title}
                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Title')}
                            errorMessage={errors.Title}
                        />

                        <CrDropdown
                            label="System Type"
                            className={styles.formField}
                            options={[
                                { key: App03WorkItemSystemTypes.PrimaryItem, text: App03WorkItemSystemTypes.PrimaryItem },
                                { key: App03WorkItemSystemTypes.GeneralItem, text: App03WorkItemSystemTypes.GeneralItem },
                                { key: App03WorkItemSystemTypes.ResolveDefect, text: App03WorkItemSystemTypes.ResolveDefect },
                                { key: App03WorkItemSystemTypes.Research, text: App03WorkItemSystemTypes.Research },
                                { key: App03WorkItemSystemTypes.ChangeRequest, text: App03WorkItemSystemTypes.ChangeRequest },
                            ]}
                            selectedKey={workItemType.SystemType}
                            onChange={(_, o) => changeHandlers.changeDropdown(o, 'SystemType')}
                            required={true}
                            errorMessage={errors.SystemType}
                        />

                        <CrTextField
                            label="Description"
                            multiline
                            rows={6}
                            maxLength={10000}
                            className={styles.formField}
                            value={workItemType.Description}
                            onChange={(ev, newValue) => changeHandlers.changeTextField(newValue, 'Description')}

                        />

                        <CrCheckbox
                            className={`${styles.formField} ${styles.checkbox}`}
                            label="Set as default"
                            checked={workItemType.IsDefault}
                            onChange={(_, isChecked) => changeHandlers.changeCheckbox(isChecked, 'IsDefault')}
                        />

                    </div>
                );
            }}
            loadEntity={id => dataServices.app03WorkItemTypeService.read(id, true, true)}
            loadNewEntity={() => new App03WorkItemType()}
            loadEntityValidations={() => new App03WorkItemTypeValidations()}
            onValidateEntity={validateEntity}
            onCreate={t => dataServices.app03WorkItemTypeService.create(t)}
            onUpdate={t => dataServices.app03WorkItemTypeService.update(t.ID, t)}
            parentEntities={dataServices.app03WorkItemTypeService.parentEntities}
        // childEntities={[
        //     {
        //         ObjectParentProperty: 'App03PortfolioUsers',
        //         ParentIdProperty: 'App03PortfolioID',
        //         ChildIdProperty: 'UserID',
        //         ChildService: dataServices.app03PortfolioUserService
        //     },
        //     {
        //         ObjectParentProperty: 'CustomFields',
        //         ParentIdProperty: 'App03PortfolioID',
        //         ChildIdProperty: 'CustomFieldDefnID',
        //         ChildService: dataServices.customFieldService
        //     },
        // ]}
        />
    );
};
